import { TreeNode } from 'primeng/api/treenode';

export const findInTree = (treeNodes: TreeNode[], matchFunc: (node: TreeNode) => boolean): TreeNode[] => {
  let results: TreeNode[] = [];
  if(treeNodes){
    treeNodes.forEach(node => {
      if (matchFunc(node)) {
        results.push(node);
      }
      if (node.children && node.children.length > 0) {
        const subNodes = findInTree(node.children, matchFunc);
        results = [...results, ...subNodes];
      }
    });
  }
  return results;
  // lost same fund groups in different business line
  // return _.chain(results).uniqBy('data.id').sortBy('label').value();
}
